import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { difference, replaceAt } from './utils.mjs';
import { notifyManager } from './notifyManager.mjs';
import { QueryObserver } from './queryObserver.mjs';
import { Subscribable } from './subscribable.mjs';
var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
  _inherits(QueriesObserver, _Subscribable);
  var _super = _createSuper(QueriesObserver);
  function QueriesObserver(client, queries) {
    var _this;
    _classCallCheck(this, QueriesObserver);
    _this = _super.call(this);
    _this.client = client;
    _this.queries = [];
    _this.result = [];
    _this.observers = [];
    _this.observersMap = {};
    if (queries) {
      _this.setQueries(queries);
    }
    return _this;
  }
  _createClass(QueriesObserver, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      var _this2 = this;
      if (this.listeners.size === 1) {
        this.observers.forEach(function (observer) {
          observer.subscribe(function (result) {
            _this2.onUpdate(observer, result);
          });
        });
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.listeners.size) {
        this.destroy();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners = new Set();
      this.observers.forEach(function (observer) {
        observer.destroy();
      });
    }
  }, {
    key: "setQueries",
    value: function setQueries(queries, notifyOptions) {
      var _this3 = this;
      this.queries = queries;
      notifyManager.batch(function () {
        var prevObservers = _this3.observers;
        var newObserverMatches = _this3.findMatchingObservers(_this3.queries); // set options for the new observers to notify of changes

        newObserverMatches.forEach(function (match) {
          return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
        });
        var newObservers = newObserverMatches.map(function (match) {
          return match.observer;
        });
        var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
          return [observer.options.queryHash, observer];
        }));
        var newResult = newObservers.map(function (observer) {
          return observer.getCurrentResult();
        });
        var hasIndexChange = newObservers.some(function (observer, index) {
          return observer !== prevObservers[index];
        });
        if (prevObservers.length === newObservers.length && !hasIndexChange) {
          return;
        }
        _this3.observers = newObservers;
        _this3.observersMap = newObserversMap;
        _this3.result = newResult;
        if (!_this3.hasListeners()) {
          return;
        }
        difference(prevObservers, newObservers).forEach(function (observer) {
          observer.destroy();
        });
        difference(newObservers, prevObservers).forEach(function (observer) {
          observer.subscribe(function (result) {
            _this3.onUpdate(observer, result);
          });
        });
        _this3.notify();
      });
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return this.result;
    }
  }, {
    key: "getQueries",
    value: function getQueries() {
      return this.observers.map(function (observer) {
        return observer.getCurrentQuery();
      });
    }
  }, {
    key: "getObservers",
    value: function getObservers() {
      return this.observers;
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(queries) {
      return this.findMatchingObservers(queries).map(function (match) {
        return match.observer.getOptimisticResult(match.defaultedQueryOptions);
      });
    }
  }, {
    key: "findMatchingObservers",
    value: function findMatchingObservers(queries) {
      var _this4 = this;
      var prevObservers = this.observers;
      var prevObserversMap = new Map(prevObservers.map(function (observer) {
        return [observer.options.queryHash, observer];
      }));
      var defaultedQueryOptions = queries.map(function (options) {
        return _this4.client.defaultQueryOptions(options);
      });
      var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
        var match = prevObserversMap.get(defaultedOptions.queryHash);
        if (match != null) {
          return [{
            defaultedQueryOptions: defaultedOptions,
            observer: match
          }];
        }
        return [];
      });
      var matchedQueryHashes = new Set(matchingObservers.map(function (match) {
        return match.defaultedQueryOptions.queryHash;
      }));
      var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
        return !matchedQueryHashes.has(defaultedOptions.queryHash);
      });
      var matchingObserversSet = new Set(matchingObservers.map(function (match) {
        return match.observer;
      }));
      var unmatchedObservers = prevObservers.filter(function (prevObserver) {
        return !matchingObserversSet.has(prevObserver);
      });
      var getObserver = function getObserver(options) {
        var defaultedOptions = _this4.client.defaultQueryOptions(options);
        var currentObserver = _this4.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new QueryObserver(_this4.client, defaultedOptions);
      };
      var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
        if (options.keepPreviousData) {
          // return previous data from one of the observers that no longer match
          var previouslyUsedObserver = unmatchedObservers[index];
          if (previouslyUsedObserver !== undefined) {
            return {
              defaultedQueryOptions: options,
              observer: previouslyUsedObserver
            };
          }
        }
        return {
          defaultedQueryOptions: options,
          observer: getObserver(options)
        };
      });
      var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
        return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
      };
      return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(observer, result) {
      var index = this.observers.indexOf(observer);
      if (index !== -1) {
        this.result = replaceAt(this.result, index, result);
        this.notify();
      }
    }
  }, {
    key: "notify",
    value: function notify() {
      var _this5 = this;
      notifyManager.batch(function () {
        _this5.listeners.forEach(function (_ref) {
          var listener = _ref.listener;
          listener(_this5.result);
        });
      });
    }
  }]);
  return QueriesObserver;
}(Subscribable);
export { QueriesObserver };